import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
import ServiceHome from "./Components/Sevices/ServiceHome";
import AboutHome from "./Components/About/AboutHome";
import WorksHome from "./Components/Works/WorksHome";
import ContactHome from "./Components/Contact/ContactHome";
import ScollToTop from "./Components/ScrollToTop";
import SocialBooth from "./Components/SocialBooth";
import ProductCommercial from "./Components/Sevices/Portfolios/ProductCommercial";
import CoperateVideo from "./Components/Sevices/Portfolios/CorporateVideo";
import RealState from "./Components/Sevices/Portfolios/RealState";
import SportsVideo from "./Components/Sevices/Portfolios/SportsVideo";
import ResortProduction from "./Components/Sevices/Portfolios/ResortProductions";
import DestinationPromotional from "./Components/Sevices/Portfolios/DestinationPromotional";
import Aerial from "./Components/Sevices/Portfolios/Aerial";
import Documentary from "./Components/Sevices/Portfolios/Documentary";

function App() {
  return (
    <div className="App" style={{ overflow: "hidden" }}>
      <BrowserRouter>
        <Navbar />
        <SocialBooth />
        <ScollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServiceHome />} />
          <Route path="/corporate-video" element={<CoperateVideo />} />
          <Route path="/resort-productions" element={<ResortProduction />} />
          <Route path="/product-commercial" element={<ProductCommercial />} />
          <Route path="/real-state-video-production" element={<RealState />} />
          <Route path="/aerial" element={<Aerial />} />
          <Route path="/documentary" element={<Documentary />} />
          <Route path="/sports-video" element={<SportsVideo />} />
          <Route path="/destination-promotional" element={<DestinationPromotional />} />
          <Route path="/about" element={<AboutHome />} />
          <Route path="/works" element={<WorksHome />} />
          <Route path="/contact" element={<ContactHome />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
